export const CompList = [
    {
        name: '广告Banner',
        component: 'Banner',
        img: 'https://img.yxdj.tech/424435825168/album/1761825269897_x90d8xqrygj.png',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '广告Banner配置',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                            }
                        }
                    },
                },
                marginTop: {
                    title: '是否具有上边距',
                    type: 'boolean',
                    widget: 'switch'
                },
            }
        }
    },
    {
        name: '运营推广位置(5 或 10个)',
        component: 'Operation',
        img: 'https://img.yxdj.tech/424435825168/album/1761825303985_40cykb0fy2n.png',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '设置推广信息',
                    type: 'array',
                    widget: 'cardList', 
                    min: 5,
                    max: 10,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'array',
                                widget: 'ChoosePage',
                            },
                            title: {
                                title: '标题',
                                type: 'string',
                                widget: 'input',
                            }
                        }
                    },
                },
            }
        }
    },
    {
        name: '优惠券展现',
        component: 'Benefit',
        img: 'https://img.yxdj.tech/424435825168/album/1761825411359_y87kplu6vxc.png',
        propsSchema: {
            type: 'object',
            properties: {
                couponList: {
                    title: '选择优惠券',
                    type: 'array',
                    widget: 'ChooseCoupon',
                },
            }
        }
    },
    {
        name: '热门商品列表',
        component: 'HotList',
        img: 'https://img.yxdj.tech/sys/images/hot-list.jpg'
    },
    {
        name: '图片列表',
        component: 'ImgList',
        img: 'https://img.yxdj.tech/sys/images/img.jpg',
        propsSchema: {
            type: 'object',
            properties: {
                list: {
                    title: '图片列表',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '基础信息',
                        type: 'object',
                        properties: {
                            src: {
                                title: '图片',
                                type: 'string',
                                widget: 'Upload',
                            },
                            link: {
                                title: '跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                            },
                            width: {
                                title: '图片宽度',
                                type: 'number',
                                widget: 'inputNumber'
                            },
                            height: {
                                title: '图片高度',
                                type: 'number',
                                widget: 'inputNumber'
                            }
                        }
                    },
                },
                marginTop: {
                    title: '是否具有上边距',
                    type: 'boolean',
                    widget: 'switch'
                },
            }
        },
        render (props) {
            const { list = [] } = props;
            if (!list || list.length <= 0) {
                return <div>请设置图片信息</div>
            }
            return (
                <div className="render-comp-image-list-content">
                    {
                        list.map(item => {
                            return <img src={'https://img.yxdj.tech/' + item?.src} className="render-comp-image-list-item" />
                        })
                    }
                </div>
            )
        }
    },
    {
        name: '顶部搜索栏',
        component: 'SearchBar',
        img: 'https://img.yxdj.tech/424435825168/album/1761825200920_b0i3k93q5vv.png',
        propsSchema: {
            type: 'object',
            properties: {
                canChooseShop: {
                    title: '是否可用选择店铺',
                    type: 'boolean',
                    widget: 'switch'
                }
            }
        }
    },
    {
        name: '商品列表模块',
        component: 'GoodsList',
        img: 'https://img.yxdj.tech/sys/images/goods-list.jpg',
        propsSchema: {
            type: 'object',
            properties: {
                title: {
                    title: '标题',
                    type: 'string',
                    widget: 'input',
                },
                goodsIds: {
                    title: '选择商品',
                    type: 'array',
                    widget: 'ChooseGoods',
                },
                column: {
                    title: '展现几列',
                    type: 'string',
                    widget: 'select',
                    props: {
                        options: [
                        { label: '1列', value: '1' },
                        { label: '2列', value: '2' },
                        ]
                    }
                }
            }
        },
        render(props) {
            const { column } = props;
            if (parseInt(column) === 1) {
                return (
                    <img src='https://img.yxdj.tech/sys/images/goods-list.jpg' />
                )
            } else {
                return (
                    <img src='https://img.yxdj.tech/424435825168/album/1761825718494_b0eg8aowr04.png' />
                )
            }
        }
    }, 
    {
        name: '模块标题',
        component: 'ModuleTitle',
        img: 'https://img.yxdj.tech/424435825168/album/1761825451140_8h80qjyglkv.png',
        propsSchema: {
            type: 'object',
            properties: {
                title: {
                    title: '标题',
                    type: 'string',
                    widget: 'input',
                },
            }
        },
        render(props) {
            const { title = '请设置标题' } = props;
            return <div style={{'padding-top': 16, 'font-size': '18px', 'text-align': 'center', 'font-weight': 'bold'}}>{title}</div>
        }
    }, 
    {
        name: '已售消息轮播',
        component: 'RollingBarrage',
        img: 'https://img.yxdj.tech/sys/images/buy-list.jpg'
    },
    {
        name: '开屏弹框',
        component: 'OperationDialog',
        img: 'https://img.yxdj.tech/424435825168/album/1761825382311_50hsnp66qik.png',
        propsSchema: {
            type: 'object',
            properties: {
                showList: {
                    title: '内容配置（按顺序优先展现）',
                    type: 'array',
                    widget: 'cardList', 
                    min: 1,
                    max: 5,
                    items: {
                        title: '弹框内容',
                        type: 'object',
                        properties: {
                            type: {
                                title: '内容',
                                type: 'string',
                                widget: 'select',
                                props: {
                                    options: [
                                        { label: '优惠券', value: 'coupon' },
                                        { label: '次卡', value: 'goodsCard' },
                                        // { label: '商品', value: 'goods' },
                                        { label: '图片', value: 'other' },
                                    ]
                                }
                            },
                            goodsCardIds: {
                                title: '选择展现次卡',
                                tooltip: '需要配置图片',
                                extra:  '若用户已购买且未使用完，则不会展现，按选择顺序依次展现',
                                type: 'array',
                                widget: 'ChooseGoodsCard',
                                hidden: '{{ rootValue.type!== "goodsCard" }}'
                            },
                            couponIds: {
                                title: '选择优惠券',
                                extra:  '若用户当前不可领取这些优惠券，则不会展现',
                                type: 'array',
                                widget: 'ChooseCoupon',
                                hidden: '{{ rootValue.type!== "coupon" }}'
                            },
                            // goodsId: {
                            //     title: '选择商品',
                            //     type: 'string',
                            //     multi: false,
                            //     widget: 'ChooseGoods'
                            // },
                            image: {
                                title: '展现图片',
                                type: 'string',
                                widget: 'Upload',
                                required: true,
                                hidden: '{{ rootValue.type === "coupon" || !rootValue.type }}'
                            },
                            link: {
                                title: '点击后跳转页面',
                                type: 'string',
                                widget: 'ChoosePage',
                                required: true,
                                hidden: '{{ rootValue.type !== "other" }}'
                            }
                        }
                    },
                }
            }
        }
    },
]  